import apiCommon from '@/api/common';

const defaultState = () => ({
	letterHeader: '',
});

const state = defaultState();

const getters = {

};

const mutations = {

	setLetterHeader(state, data) {
		state.letterHeader = data.data;
	},
};

const actions = {
	getLetterHeader({ commit }, params) {
		apiCommon.getLetterHeader(params).then(({ data: { data } }) => {
			commit('setLetterHeader', { data: data.results });
		}).catch(() => {
			commit('setLetterHeader', { data: '' });
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};